module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "upload_planta_dialog",
    attrs: {
      "md-open-from": "#inicia_processo",
      "md-close-to": "#inicia_processo"
    }
  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('md-dialog-content', [_c('md-input-container', [_c('label', [_vm._v("Selecione uma imagem")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "accept": "image/*"
    },
    on: {
      "selected": _vm.onBluePrintSelected
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('md-spinner', {
    staticClass: "loading",
    attrs: {
      "md-indeterminate": ""
    }
  }) : _c('div', [_c('md-image', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.previewSrc),
      expression: "previewSrc"
    }],
    ref: "imagePreview",
    attrs: {
      "md-src": _vm.previewSrc
    },
    on: {
      "load": _vm.revokeURL
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("Cancelar\n    ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.confirmSelectedBlueprint
    }
  }, [_vm._v("Prosseguir\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b171246","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlueprintDialog.vue
// module id = 829
// module chunks = 1